<template>
  <div>
    <div class="config-card-content">
      <a-row :gutter="18">
        <a-col :span="8">
          <a-card>
            <slot name="left" />
          </a-card>
        </a-col>
        <a-col :span="16">
          <a-card>
            <slot name="right" />
          </a-card>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="less" scoped>
/deep/.config-card-content{
  height: calc(~'100vh - 130px');
  >.ant-row{
    height: 100% !important;
    >.ant-col{
      height: 100% !important;
      >.ant-card{
       height: 100% !important;
       >.ant-card-body{
        height: 100% !important;
        >div{
          height: 100% !important;
          >div{
            display: flex;
            flex-direction: column;
            >.content{
              flex: 1;
              overflow-y: auto;
            }
          }
        }
       }
      }
    }
  }
}

</style>
